<template>
<div>
    <!-- <v-tabs v-model="tab">
        <v-tab>Agreements</v-tab>
        <v-tab>Header/Footer Template</v-tab>
    </v-tabs> -->
    <div v-if="tab==0">
        <v-layout justify-left wrap mt-2>
            <v-flex xs2>
                <v-list subheader :key="agreementKey">
                    <v-subheader style="background: #f0f0f0">Templates <v-spacer></v-spacer>
                        <v-btn icon small @click="addTemplate()">
                            <v-icon small>add</v-icon>
                        </v-btn>
                    </v-subheader>
                    <v-list-tile v-for="agreement in agreements" :key="agreement.id" @click="selectedAgreement = agreement">
                        <v-list-tile-action v-if="selectedAgreement&&selectedAgreement.id == agreement.id">
                            <v-icon color="green">check</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 12px">{{ agreement.name }}</v-list-tile-title>
                            <v-list-tile-sub-title style="font-size: 12px">{{ agreement.type }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-btn icon small @click="updateAgreements({id: agreement.id, isActive: false, isDeleted: true})">
                                <v-icon color="red" small>delete</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-flex>
            <v-flex xs10 v-if="selectedAgreement">
                <v-toolbar flat color="white" :key="variableKey">
                    <v-toolbar-title>
                        {{selectedAgreement.name}}
                        <v-btn icon small @click="editAgreement(selectedAgreement)">
                            <v-icon small>edit</v-icon>
                        </v-btn>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-chip style="cursor: pointer" v-if="selectedAgreement.variables&&selectedAgreement.variables.length>0" small outline @click="variableForm=true">
                        <v-icon small class="mr-1">description</v-icon>
                        {{selectedAgreement.variables.length}} Variables
                    </v-chip>
                    <v-btn icon small v-if="selectedAgreement.content" @click="downloadAgreement(selectedAgreement)">
                        <v-icon small v-if="!loadingDownload">download</v-icon>
                        <v-progress-circular v-else indeterminate size="20" color="grey"></v-progress-circular>
                    </v-btn>
                    <v-btn icon small v-if="editAgreementContact" @click="updateAgreements(selectedAgreement)">
                        <v-icon small>save</v-icon>
                    </v-btn>
                    <v-btn icon small v-if="!editAgreementContact" @click="editAgreementContact=true">
                        <v-icon small>edit</v-icon>
                    </v-btn>
                    <v-btn icon small @click="updateAgreements({id: agreement.id, isActive: false, isDeleted: true})">
                        <v-icon color="red" small>delete</v-icon>
                    </v-btn>

                </v-toolbar>
                <v-layout justify-center>
                    <v-flex xs9 px-1 v-if="editAgreementContact">
                        <v-textarea auto-grow @keydown.ctrl.83.prevent.stop="saveInsideComponent" color="black" flat solo style="font-size: 12px;overflow-y: auto; height: 80vh; border: 1px solid grey;" v-model="selectedAgreement.content"></v-textarea>
                    </v-flex>   
                    <v-flex v-else xs12 px-1 :key="selectedAgreement.id">
                        <vue-markdown :source="selectedAgreement.content" class="text-xs-left" style="width: 100%;overflow-y: auto; max-height: 80vh"></vue-markdown>
                    </v-flex>
                    <v-flex xs3 v-if="editAgreementContact">
                        <v-list dense style="overflow-y: auto; max-height: 80vh">
                            <v-subheader style="background: #f0f0f0">Variables</v-subheader>
                            <v-btn v-for="(variable, i) in orderedVariables" :key="i" outline flat style="text-transform: none; width: 90%; padding: 10px" dense draggable="true" @dragstart="drag($event)" :value="`{{${variable}}}`">{{variable}}</v-btn>
                        </v-list>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
    <v-dialog v-model="modal" persistent width="750px">
        <v-card v-if="item">
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    {{item.modalType}} Agreement
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="!item.id" outline color="black" flat @click="createAgreement()" :disabled="!item.name || !item.type">Save</v-btn>
                <v-btn v-else outline color="black" flat @click="updateAgreements(item)" :disabled="!item.name || !item.type">Save</v-btn>

                <v-btn flat @click="modal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap justify-center>
                    <v-flex xs10 mx-1>
                        <v-text-field v-model="item.name" label="Agreement Name" box></v-text-field>
                    </v-flex>
                    <v-flex xs10 mx-1>
                        <v-text-field v-model="item.type" label="Type of Agreement" box></v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="variableForm" persistent width="750px">
        <v-card v-if="selectedAgreement&&selectedAgreement.variables">
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    {{selectedAgreement.name}}: Variables
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="variableForm=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap justify-start>
                    <v-flex v-for="(variable, i) in selectedAgreement.variables" :key="i">
                        <v-chip small>{{variable}}</v-chip>
                    </v-flex>
                </v-layout>
                <!-- <v-list dense>
                    <v-list-tile style="height: 30px; border-bottom: 1px solid lightgrey" v-for="(variable, i) in selectedAgreement.variables" :key="i">
                        <v-list-tile-title style="font-size: 12px"></v-list-tile-title>
                    </v-list-tile>

                </v-list> -->
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "../services/Api";
import {
    PrismEditor
} from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import {
    highlight,
    languages
} from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-markup';

// import 'prismjs/components/prism-markdown';

// import 'prismjs/components/prism-markdown';
// const Prism = require('prismjs');
import 'prismjs/themes/prism-tomorrow.css';
import VueMarkdown from 'vue-markdown'
export default {
    components: {
        PrismEditor,
        VueMarkdown
    },
    data() {
        return {
            agreements: [],
            agreementKey: 0,
            content: "",
            editAgreementContact: false,
            item: {},
            loadingDownload: false,
            modal: false,
            selectedAgreement: null,
            types: ["Platform As A Service"],
            tab: 0,
            variableForm: false,
            variableKey: 0
        };
    },
    computed: {
        orderedVariables() {
            let result = []
            if (this.selectedAgreement && this.selectedAgreement.variables) {
                result = this.selectedAgreement.variables
            }
            result.sort()
            return result
        }
    },
    watch: {
        async selectedAgreement(val) {
            if (val) {
                this.selectedAgreement.variables = await this.getVariables(val.content)
                this.editAgreementContact = false
                this.variableKey++
            }
        }
    },
    created() {
        this.getAgreements()
    },
    mounted() {
        document.addEventListener("keydown", this.doSave);
    },

    beforeDestroy() {
        document.removeEventListener("keydown", this.doSave);
    },
    methods: {
        addTemplate() {
            this.item = {
                modalType: 'Add'
            }
            this.modal = true
        },
        async doSave(e) {
            if (!(e.keyCode === 83 && (e.ctrlKey || e.metaKey))) {

                return;
            }

            this.updateAgreements(this.selectedAgreement)
            this.selectedAgreement.variables = await this.getVariables(this.selectedAgreement.content)

            this.variableKey++

            e.preventDefault();
            console.log("saving from DOM!");
        },

        downloadAgreement(item) {
            this.loadingDownload = true
            Api().get('/admin/agreements/downloadPdf/' + item.id).then(response => {
                let file = Buffer.from(response.data, "base64");
                const linkSource = `data:application/pdf;base64,${response.data}`;
                const downloadLink = document.createElement("a");
                const fileName = item.name + '.pdf'
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                this.loadingDownload = false

            })
        },
        editAgreement(item) {
            this.item = item
            this.item.modalType = 'Edit'
            this.modal = true
        },
        drag(event) {
            event.dataTransfer.setData("text", event.target.value);
        },

        /*
         * To set the value from dragged element into an object 
         *
         * @return void
         */
        drop(event) {
            console.log(event)
            event.target.value += event.dataTransfer.getData("text");
            this.setText(event.target.value);
            this.selectedAgreement.content = event.target.value; // update the value of _paragraph.
        },

        /*
         * To prevent some actions when dropping value
         *
         * @return void
         */
        allowDrop(event) {
            event.preventDefault()
        },
        highlighterMD(code) {
            return highlight(code, languages.markup); //returns html
        },
        highlighterHTML(code) {
            return highlight(code, languages.markup); //returns html
        },
        getAgreements() {
            Api().get('/admin/agreements').then(res => {
                this.agreements = res.data
                if (this.agreements.length > 0 && !this.selectedAgreement) {
                    this.selectedAgreement = this.agreements[0]
                }
                this.agreementKey++
            })
        },
        getVariables(content) {
            let variables = []
            if (content) {
                // const s = "My cow always gives milk, thier cow also gives milk";
                const matches = content.matchAll(/{{(.*?)}}/g);
                // let split = content.replace(/\n/g, ' ').split(' ')
                // variables = split.filter(x => x.includes('{{') && x.includes('}}'))
                // variables = [...new Set(variables.map(x=>x))]
                // variables = variables.map(x => x.replace('{{', '').replace('}}', ''))
                variables = Array.from(matches, x => x[1])
                variables = [...new Set(variables)]
            }
            return variables
        },
        createAgreement() {
            Api().post('/admin/agreements', this.item).then(res => {
                this.selectedAgreement = res.data
                this.getAgreements()
                this.modal = false
                this.item = {}
            })
        },
        updateAgreements(item) {
            Api().put('/admin/agreements/' + item.id, item).then(res => {
                this.getAgreements()
                if (!item.isActive) {
                    this.selectedAgreement = null
                }
                this.editAgreementContact = false
                this.modal = false
                this.item = {}
            })
        }
    }
};
</script>

<style scoped>
.my-editor {
    /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
    background: #fff;
    color: black;

    /* you must provide font-family font-size line-height. Example: */
    /* font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace; */
    font-size: 12px;
    line-height: 1.5;
    padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
    outline: none;
}
</style>
